var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddwidget = function SvgAddwidget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "addwidget-a",
    d: "M32 47c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-2c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13zm-2.857-12C28.512 33 28 32.552 28 32s.512-1 1.143-1h5.714c.631 0 1.143.448 1.143 1s-.512 1-1.143 1h-5.714zM31 29.143c0-.631.448-1.143 1-1.143s1 .512 1 1.143v5.714c0 .631-.448 1.143-1 1.143s-1-.512-1-1.143v-5.714z"
  })));
};
export default SvgAddwidget;